export function ScanlineOverlay() {
  return (
    <>
      {/* Static scanlines */}
      <div
        className="fixed inset-0 pointer-events-none z-50"
        style={{
          background: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0, 0, 0, 0.03) 2px, rgba(0, 0, 0, 0.03) 4px)',
        }}
      />

      {/* Moving scanline */}
      <div
        className="fixed inset-0 pointer-events-none z-50 overflow-hidden"
      >
        <div
          className="absolute w-full h-[2px] bg-cyber-green/10 animate-scanline"
          style={{
            boxShadow: '0 0 10px rgba(0, 255, 65, 0.3)',
          }}
        />
      </div>

      {/* CRT vignette effect */}
      <div
        className="fixed inset-0 pointer-events-none z-40"
        style={{
          background: 'radial-gradient(ellipse at center, transparent 0%, rgba(0, 0, 0, 0.3) 100%)',
        }}
      />
    </>
  );
}
